import { optionTitle_signature } from 'owa-signature-option/lib/SignatureOption.locstring.json';
import { isFeatureEnabled } from 'owa-feature-flags';
import getShownView from 'owa-pbp-option/lib/selectors/getShownView';
import PersonalBookingPageShownView from './data/store/schema/PersonalBookingPageShownView';
import getAnonymousSharingStatus from 'owa-pbp-option-publishing-settings/lib/selectors/getAnonymousSharingStatus';

import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullSignaturePbpOption'));
let SignaturePbpOption: LazyOption = createLazyOption(
    {
        key: 'includePbpSignatureOption',
        titleStringKey: optionTitle_signature,
        searchTermsStringKey: optionTitle_signature,
        isHidden: () => {
            return (
                !isFeatureEnabled('cal-personalbookingpage') ||
                !isFeatureEnabled('cal-pbp-addpsplinktosignature') ||
                getShownView() != PersonalBookingPageShownView.EditSignature ||
                !getAnonymousSharingStatus()
            );
        },
    },
    lazyFullModule,
    m => m.default
);
export default SignaturePbpOption;
